var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdersActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "23px",
    viewBox: "0 0 20 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "catalog copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(-43.000000, -212.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "catalog-copy-3",
    transform: "translate(43.000000, 212.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0714286,0 L3.28571429,0 C2.37838934,0 1.64285714,0.735532197 1.64285714,1.64285714 L1.64285714,4.92857143 L0,4.92857143 L0,6.57142857 L1.64285714,6.57142857 L1.64285714,10.6785714 L0,10.6785714 L0,12.3214286 L1.64285714,12.3214286 L1.64285714,16.4285714 L0,16.4285714 L0,18.0714286 L1.64285714,18.0714286 L1.64285714,21.3571429 C1.64285714,22.2644678 2.37838934,23 3.28571429,23 L18.0714286,23 C18.9787535,23 19.7142857,22.2644678 19.7142857,21.3571429 L19.7142857,1.64285714 C19.7142857,0.735532197 18.9787535,0 18.0714286,0 Z M18.0714286,21.3571429 L3.28571429,21.3571429 L3.28571429,18.0714286 L4.92857143,18.0714286 L4.92857143,16.4285714 L3.28571429,16.4285714 L3.28571429,12.3214286 L4.92857143,12.3214286 L4.92857143,10.6785714 L3.28571429,10.6785714 L3.28571429,6.57142857 L4.92857143,6.57142857 L4.92857143,4.92857143 L3.28571429,4.92857143 L3.28571429,1.64285714 L18.0714286,1.64285714 L18.0714286,21.3571429 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8.21428571,
    y: 4.92857143,
    width: 6.57142857,
    height: 1.64285714
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8.21428571,
    y: 10.6785714,
    width: 6.57142857,
    height: 1.64285714
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8.21428571,
    y: 16.4285714,
    width: 6.57142857,
    height: 1.64285714
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersActive);
export default __webpack_public_path__ + "static/media/orders-active.92a988dd11d72a6cce10d771da53e3cc.svg";
export { ForwardRef as ReactComponent };